import styled from 'styled-components';
import { FlexColumn, FormControls } from '@elementary/common-ui/components';
import { TextField as MuiTextField } from '@mui/material';
import { UseFormReturn } from 'react-hook-form';
import { AddTestForm } from 'shared/types';

const TitleField = styled(MuiTextField)<{ $hasError?: boolean }>`
  & .MuiInputBase-input {
    font-size: 22px;
    font-weight: 600;
    padding: 0;
    color: ${({ theme, $hasError }) =>
      $hasError ? theme.palette.common.red : theme.palette.common.black};
  }

  & .MuiInputBase-input::placeholder {
    opacity: 1;
    font-weight: 600;
    color: ${({ theme, $hasError }) =>
      $hasError ? theme.palette.common.red : theme.palette.common.gray2};
  }
`;

const DescriptionField = styled(MuiTextField)`
  & .MuiInputBase-input {
    font-size: 14px;
    padding: 0;
    color: ${({ theme }) => theme.palette.common.black};
  }

  & .MuiInputBase-input::placeholder {
    opacity: 1;
    color: ${({ theme }) => theme.palette.common.gray2};
  }
`;

type Props = {
  methods: UseFormReturn<AddTestForm>;
  titleField?: 'testName' | 'testNameOverride';
  titleValidate?: (value: string | undefined) => true | string;
};

const TestHeader = ({
  methods,
  titleField = 'testName',
  titleValidate,
}: Props) => {
  const { ref: titleRef, ...titleRest } = methods.register(titleField, {
    validate: titleValidate,
  });
  const { ref: descriptionRef, ...descriptionRest } =
    methods.register('description');
  const titleError = methods.formState.errors[titleField]?.message;

  return (
    <FlexColumn sx={{ gap: 0.5 }}>
      <FormControls.InputWrapper>
        <TitleField
          fullWidth
          variant="standard"
          placeholder="Untitled"
          autoComplete="off"
          InputProps={{ disableUnderline: true }}
          inputProps={{ 'aria-label': 'Test name' }}
          inputRef={titleRef}
          {...titleRest}
          error={!!titleError}
          $hasError={!!titleError}
        />
        <FormControls.ErrorMessage>{titleError}</FormControls.ErrorMessage>
      </FormControls.InputWrapper>
      <DescriptionField
        fullWidth
        multiline
        variant="standard"
        placeholder="Add a description…"
        autoComplete="off"
        InputProps={{ disableUnderline: true }}
        inputRef={descriptionRef}
        {...descriptionRest}
      />
    </FlexColumn>
  );
};

export default TestHeader;
